<template>
  <div class="my-group">
    <div class="head" @click="changeDrop">
      <p class="title">接收小组</p>
      <img src="../../../assets/images/grade/drop-down.png" alt="" class="icon-drop" v-if="isDropDown"/>
      <img src="../../../assets/images/grade/drop-up.png" alt="" class="icon-drop" v-else/>
    </div>
    <ul class="menu-group" v-if="isDropDown">
      <li class="group-li" v-for="(item,index) in list" :key="index" @click="changeGroup(index)">
        <img
            src="@/assets/images/grade/select.png"
            v-if="item && item.checkedPush"
            class="icon-check"
            alt=""
          />
        <img
            src="@/assets/images/teacher-task/un-select.png"
            v-else
            class="icon-check"
            alt=""
          />
        <p class="title">{{ item && item.groupName }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { addClassGroup } from '@/api/grade'
export default {
  props: {
    classId: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  data() {
    return {
      list: [],
      isDropDown: true,
      selectedIds: [],
      groupIds: [],
    }
  },
  watch: {
    model(newVal) {
      if (newVal.postGroups && newVal.postGroups.length) {
        let array = newVal.postGroups.filter(acc => acc.isSelected === 1).map(acc => acc.id)
        this.selectedIds.push(...array)
        this.handleCheckSelect(array)
      }
    },
  },
  async created() {
    await this.onLoad()
  },
  mounted() {
    if (localStorage.getItem('addMockCon')) {
      let {groupIds} = JSON.parse(localStorage.getItem('addMockCon'))
      this.groupIds = groupIds
    }
    if (localStorage.getItem('addIEPCon')) {
      let {groupIds} = JSON.parse(localStorage.getItem('addIEPCon'))
      this.groupIds = groupIds
    }
    if (sessionStorage.getItem('addGradeExamine')) {
      this.groupIds = JSON.parse(`${sessionStorage.getItem('addGradeExamine')}`)
    }
  },
  methods: {
    // 分组列表
    onLoad() {
      addClassGroup(this.classId).then(res => {
        this.list = res.data
        if (this.groupIds && this.groupIds.length) {
          this.list.forEach(acc => {
            if (this.groupIds.includes(acc.id)) {
              acc.checkedPush = true
            } else {
              acc.checkedPush = false
            }
          })
          this.$forceUpdate()
        }
      })
    },
    handleCheckSelect(array) {
      if (array.length && this.list.length) {
        this.list.forEach(acc => {
          if (array.includes(acc.id)) {
            acc.checkedPush = true
          } else {
            acc.checkedPush = false
          }
        })
        this.$forceUpdate()
      }
    },
    changeDrop() {
      this.isDropDown = !this.isDropDown
    },
    changeGroup(index) {
      const id = this.list[index].id
      this.list[index].checkedPush = !this.list[index].checkedPush
      if (this.list[index].checkedPush) {
        // 添加选中 ID
        if (!this.selectedIds.includes(id)) {
          this.selectedIds.push(id)
        }
      } else {
        // 移除未选中 ID
        this.selectedIds = this.selectedIds.filter(selectedId => selectedId !== id)
      }
      // 通过 $emit 将更新的 selectedIds 传递给父组件
      this.$emit('update:selection', this.selectedIds)
      this.$forceUpdate()
    },
  }

}
</script>

<style  scoped lang="less">
.my-group{
  position: relative;
  .head{
    display: flex;
    align-items: center;
    .title{
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0,0,0,0.6);
      margin-right: 6px;
    }
    .icon-drop{
      width: 14px;
    }

  }
}
.menu-group{
  margin-top: 20px;
  position: relative;
  margin-bottom: 14px;
  .group-li{
    width: 100%;
    height: 18px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 18px;
    overflow: hidden;
    white-space: nowrap;
    &:last-child{
      margin-bottom: 0;
    }
    .icon-check{
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
    .title{
      font-weight: 500;
      font-size: 14px;
      color: rgba(0,0,0,0.6);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/addGroup.vue